import { AlertColor } from '@mui/material/Alert';

// Global toast state
interface ToastState {
  showToast: (message: string, severity: AlertColor, duration?: number) => void;
}

// Toast types
export type ToastType = 'success' | 'error' | 'info' | 'warning';

// This is a singleton that will be used to access the toast functionality
// from outside of React components
let toastState: ToastState | null = null;

// Function to set the toast state
export const setToastState = (state: ToastState) => {
  toastState = state;
};

// Toast function
const toast = {
  success: (message: string, duration?: number) => {
    console.log(`%c✓ Success: ${message}`, 'color: green; font-weight: bold');
    
    if (toastState) {
      toastState.showToast(message, 'success', duration);
    } else {
      // Fallback if toast provider is not available
      alert(`Success: ${message}`);
    }
  },
  
  error: (message: string, duration?: number) => {
    console.log(`%c✗ Error: ${message}`, 'color: red; font-weight: bold');
    
    if (toastState) {
      toastState.showToast(message, 'error', duration);
    } else {
      // Fallback if toast provider is not available
      alert(`Error: ${message}`);
    }
  },
  
  info: (message: string, duration?: number) => {
    console.log(`%cℹ Info: ${message}`, 'color: blue; font-weight: bold');
    
    if (toastState) {
      toastState.showToast(message, 'info', duration);
    } else {
      // Fallback if toast provider is not available
      alert(`Info: ${message}`);
    }
  },
  
  warning: (message: string, duration?: number) => {
    console.log(`%c⚠ Warning: ${message}`, 'color: orange; font-weight: bold');
    
    if (toastState) {
      toastState.showToast(message, 'warning', duration);
    } else {
      // Fallback if toast provider is not available
      alert(`Warning: ${message}`);
    }
  }
};

export default toast;